import {
  CfHeaderLiteProps,
  CfHeaderMenuLiteData,
  headerLiteSchema,
} from "components/HeaderNew/HeaderLite/CfHeaderLite/schema";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { HeaderLiteDataProps } from "components/HeaderNew/HeaderLite/types";
import { LiveInspectorData } from "types/types";
import { assert } from "superstruct";
import {
  convertMenuLite,
  convertSettingsLite,
} from "components/HeaderNew/utils";
import HeaderLite, { HeaderLiteProps } from "components/HeaderNew/HeaderLite";
import React from "react";

export const convertCfHeaderMenuLiteProps = ({
  dataJson,
}: CfHeaderMenuLiteData) => {
  if (process.env.GATSBY_ENV !== "production") {
    try {
      assert(dataJson, headerLiteSchema);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("validation HeaderLite", error);
    }
  }

  const { menu, settings } = dataJson;

  const props: HeaderLiteDataProps = {
    menu: convertMenuLite(menu),
    settings: convertSettingsLite(settings),
  };

  return props;
};

export const convertCfHeaderLiteProps = ({
  menu,
  liveInspector,
}: CfHeaderLiteProps) => {
  const props: HeaderLiteProps = {
    data: convertCfHeaderMenuLiteProps(menu),
    liveInspector,
  };

  return props;
};

const CfHeaderLite = (props: CfHeaderLiteProps) => {
  const liveInspector: LiveInspectorData = {
    header: ContentfulLivePreview.getProps({
      entryId: props.contentful_id,
      fieldId: "entryTitle",
    }),
  };

  return (
    <HeaderLite {...convertCfHeaderLiteProps({ ...props, liveInspector })} />
  );
};

export default CfHeaderLite;
